import app from '@lib/js/index';

export { app };

export default {
  install: (application) => {
    Object.assign(application.config.globalProperties, { app });
    application.provide('app', app);
  },
};
